export const getServer = () => process.env.REACT_APP_API_URL;
export const apiKey = () => process.env.REACT_APP_API_KEY;
